/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- MONETIZATION - REVENUE PAGE : STYLES --------------- ++++++++++ */
export default {
    revenue: {
    }
};
